import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { firstValueFrom } from 'rxjs';

import init, * as wasm from '../../../../public/wasm/track-renderer';

@Injectable({
  providedIn: 'root',
})
export class TrackRendererService {
  private http = inject(HttpClient);
  private wasmTrack: any;
  private wasmReady: Promise<wasm.InitOutput> | null = null;
  private points: number[] = [];
  private trackOrigin: [number, number] = [0, 0];

  constructor() {
    this.wasmReady = init('wasm/track-renderer_bg.wasm');
  }

  async loadWasm() {
    await this.wasmReady;
  }

  async loadTrack(path: string) {
    await this.wasmReady;
    const jsonText = await firstValueFrom(this.http.get(path, { responseType: 'text' }));
    const geojson = JSON.parse(jsonText);

    const coords: [number, number][] =
      geojson.type === 'FeatureCollection'
        ? geojson.features[0].geometry.coordinates
        : geojson.coordinates;

    const [originLon, originLat] = coords[0];

    this.points = coords
      .map(([lon, lat]) => {
        const x = (lon - originLon) * 111_230.0 * Math.cos((lat * Math.PI) / 180);
        const y = (lat - originLat) * 110_540.0;
        return [x, y];
      })
      .flat();

    this.wasmTrack = wasm.Track.from_flat(new Float32Array(this.points), 2000);
    this.trackOrigin = coords[0];
  }

  getPoints(): number[] {
    return this.points;
  }

  getSplineLength(): number {
    return this.wasmTrack?.spline_length;
  }

  closestTOnSpline(x: number, y: number): number {
    return this.wasmTrack?.closest_t(x, y);
  }

  tToDistance(t: number): number {
    return this.wasmTrack?.t_to_distance(t);
  }

  distanceToT(s: number): number {
    return this.wasmTrack?.distance_to_t(s);
  }

  interpolateSpline(t: number): [number, number] {
    const arr: any = this.wasmTrack?.interpolate(t);
    return [arr[0], arr[1]];
  }

  latLonToXY(lat: number, lon: number): [number, number] {
    if (this.points.length === 0) throw new Error('Track not yet loaded');
    const [originLon, originLat] = this.trackOrigin;
    const x = (lon - originLon) * 111_230.0 * Math.cos((lat * Math.PI) / 180);
    const y = (lat - originLat) * 110_540.0;
    return [x, y];
  }
}
